import * as types from '../actions/types';

const initialState = {
    searchdata:[]
}

export default function SearchcriteriaReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_CRITERIA:
            return {
               
                searchdata:action.payload,
            } 
        default:
            return state
    }
}
